(function () {
  'use strict';

  /* ---- nav background on scroll ---- */
  var nav = document.getElementById('nav');
  if (nav) {
    var onNavScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 40); };
    onNavScroll();
    window.addEventListener('scroll', onNavScroll, { passive: true });
  }

  /* ---- mobile menu ---- */
  var menuBtn = document.getElementById('menuBtn');
  var mobileMenu = document.getElementById('mobileMenu');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('hidden');
      menuBtn.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ---- hero slideshow ---- */
  var slideshow = document.getElementById('heroSlideshow');
  if (slideshow) {
    var slides = Array.prototype.slice.call(slideshow.querySelectorAll('[data-slide]'));
    var dotsWrap = slideshow.querySelector('[data-dots]');
    var cur = 0, timer;
    if (slides.length && dotsWrap) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.className = 'dot' + (i === 0 ? ' on' : '');
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () { go(i, true); });
        dotsWrap.appendChild(b);
      });
      var dots = Array.prototype.slice.call(dotsWrap.children);

      var go = function (i, manual) {
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('on', k === cur); });
        dots.forEach(function (d, k) { d.classList.toggle('on', k === cur); });
        if (manual) restart();
      };
      var restart = function () {
        clearInterval(timer);
        timer = setInterval(function () { go(cur + 1); }, 6000);
      };
      var prev = slideshow.querySelector('[data-prev]');
      var next = slideshow.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { go(cur - 1, true); });
      if (next) next.addEventListener('click', function () { go(cur + 1, true); });
      restart();
    }
  }

  /* ---- product gallery thumbs ---- */
  document.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = document.getElementById(t.getAttribute('data-main'));
      if (main && t.getAttribute('data-src')) main.src = t.getAttribute('data-src');
    });
  });

  /* ---- purchase options (one-time / subscription) ---- */
  document.querySelectorAll('[data-purchase-options]').forEach(function (box) {
    var hidden = box.querySelector('[data-selling-plan]');
    box.addEventListener('change', function (e) {
      if (e.target.name === 'po' && hidden) hidden.value = e.target.value || '';
    });
  });

  /* ---- scroll reveal ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
  }
})();
